import { rei } from "@/services/api"

class CargaProclamasService {
  static gerarXml (data) {
    return rei.post(`carga-proclamas/gerar-xml`, data).then(res => res.data)
  }

  static enviarXmlAssinado (data) {
    return rei.post(`carga-proclamas/enviar-xml-assinado`, data).then(res => res.data)
  }

  static validarIntegracaoEProclamas (data) {
    return rei.post(`carga-proclamas/validar-integracao-eproclamas`, data).then(res => res.data)
  }
}

export default CargaProclamasService
